export const SSO_TEST_CONNECTION_RESULTS = 'SSO_TEST_CONNECTION_RESULTS';
export const SSO_TEST_ICON_CONNECTION_RESULTS = 'SSO_TEST_ICON_CONNECTION_RESULTS';
export const SSO_TEST_CONNECTION_SETTINGS = 'SSO_TEST_CONNECTION_SETTINGS';
export const ALL_SSO_APPS_RECEIVED = 'ALL_SSO_APPS_RECEIVED';
export const SSO_APPS_CORE_APPS = 'SSO_APPS_CORE_APPS';
export const SSO_APPS_LOGIN_APPS = 'SSO_APPS_LOGIN_APPS';
export const APP_UI_MSGS = 'APP_UI_MSGS';
export const APP_KEY_YJ = 'YJ';
